import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { IoArrowBackOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, updateUser } from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import FormContainer from "../components/FormContainer";
import { USER_UPDATE_RESET } from "../constants/userConstants";
import Navbar from "../components/Navbar";
import "../App.css";
import Multiselect from "multiselect-react-dropdown";
import { listProducts } from "../actions/productActions";

const UserEditScreen = ({ match, history }) => {
  const [message, setMessage] = useState(null);
  const userId = match.params.id;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState("USER");
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const userDetails = useSelector((state) => state.userDetails);
  const { loading, error, user } = userDetails;
  const userUpdate = useSelector((state) => state.userUpdate);
  const productList = useSelector((state) => state.productList);
  const [genSetAssigned, setGenSetAssigned] = useState([]);
  const [resetPassword, setResetPassword] = useState(false);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = userUpdate;

  useEffect(() => {
    dispatch(listProducts());
    if (successUpdate) {
      dispatch({ type: USER_UPDATE_RESET });
      history.push("/admin/userlist");
    } else {
      if (!user.username || user._id !== userId) {
        dispatch(getUserDetails(userId));
      } else {
        setUsername(user.username);
        setEmail(user.email);
        setAddress(user.address);
        setContact(user.contact);
        setIsAdmin(user.isAdmin);
        setRole(user.role);
        setGenSetAssigned(user.assignedGensets ? user.assignedGensets : []);
      }
    }
  }, [dispatch, history, user, userId, successUpdate]);

  const submitHandler = (e) => {
    e.preventDefault();
    const updateObject = {
      _id: userId,
      username,
      email,
      contact,
      address,
      isAdmin,
      role,
      assignedGensets: genSetAssigned,
    }
    if (resetPassword) {
      if (password !== confirmPassword) {
        setMessage("Password do not match");
        return;
      } else {
        updateObject.password = password
        setMessage(null);
      }
    }
    dispatch(
      updateUser(updateObject)
    );
  };
  console.log(genSetAssigned)
  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <Link
        to="/admin/userlist"
        className="tw-flex tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-ml-10 tw-mt-5 tw-rounded-full hover:tw-bg-gray-200"
      >
        <IoArrowBackOutline className="tw-text-blueGray-400 tw-text-4xl" />
      </Link>
      <div className="tw-w-3/4 md:tw-w-1/2 tw-my-8 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-p-1 tw-border-1 tw-rounded-lg tw-shadow-2xl">
        <FormContainer className="tw-my-12">
          <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center tw-my-4">
            Edit User
          </h3>
          {loadingUpdate && <Loader />}
          {message && <Message variant="danger">{message}</Message>}
          {errorUpdate && <Message variant="danger">{errorUpdate}</Message>}
          {loading ? (
            <Loader />
          ) : error ? (
            <Message variant="danger">{error}</Message>
          ) : (
            <Form onSubmit={submitHandler}>
              <Form.Group className="tw-py-2" controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="name"
                  placeholder="Enter Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="email">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled
                  style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                ></Form.Control>
                <Form.Text className="text-muted">
                  Email address cannot be changed
                </Form.Text>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="contact">
                <Form.Label>Contact</Form.Label>
                <Form.Control
                  type="contact"
                  placeholder="Enter Contact"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="address"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="role">
                <Form.Label>Assigned Role</Form.Label>
                <Form.Control
                  as="select"
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                  }}
                >
                  {userInfo.role === "LOCAL_ADMIN" && (
                    <option value="USER">User</option>
                  )}
                  {userInfo.role === "MAIN_ADMIN" && (
                    <option value="LOCAL_ADMIN">Local Admin</option>
                  )}
                  {userInfo.role === "MAIN_ADMIN" && (
                    <option value="MAIN_ADMIN">Main Admin</option>
                  )}
                </Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Check type={"checkbox"}>
                  <Form.Check.Input
                    type={"checkbox"}
                    defaultChecked={resetPassword}
                    value={resetPassword}
                    onClick={(e) => {
                      setResetPassword(!resetPassword);
                    }}
                  />
                  <Form.Check.Label>Reset Password</Form.Check.Label>
                </Form.Check>
              </Form.Group>
              {resetPassword && (
                <>
                  <Form.Group className="tw-py-2" controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group className="tw-py-2" controlId="confirmPassword">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirm password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </>
              )}
              <Form.Group className="tw-py-2" controlId="role">
                <Multiselect
                  style={{ backgroundColor: "#fff" }}
                  selectedValues={genSetAssigned}
                  options={productList.products.map((e) => ({
                    key: `${e.gensetNumber}`,
                    value: e._id,
                  }))}
                  displayValue="key"
                  onSelect={(e) => setGenSetAssigned(e)}
                  onRemove={e => setGenSetAssigned(e)}
                />
              </Form.Group>
              <br />
              <Button
                type="submit"
                className="tw-mb-8 tw-px-16 tw-block tw-mx-auto tw-transition tw-duration-700 tw-ease-in-out tw-transform hover:-tw-translate-y-1 hover:tw-scale-110 myButton"
              >
                Update
              </Button>
            </Form>
          )}
        </FormContainer>
      </div>
    </>
  );
};

export default UserEditScreen;
